var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrimsonFlameActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 116.8,
    y1: 69.6,
    x2: 111.1,
    y2: 113.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec1c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 84.7,
    y1: 89.6,
    x2: 73.9,
    y2: 118.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec1c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 190.5,
    y1: 43.9,
    x2: 180.8,
    y2: 119.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec1c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 123.6,
    y1: 40,
    x2: 116.7,
    y2: 52.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec1c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: -39.8,
    y1: 84.4,
    x2: -36.7,
    y2: 42.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ec1c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec7e21"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1)}.c{fill:url(#g2)}.d{fill:url(#g3)}.e{fill:url(#g4)}.f{fill:url(#g5)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.5 64.2c0 35.1-28.4 63.6-63.5 63.6-35.1 0-63.6-28.5-63.6-63.6 0-35.1 28.5-63.5 63.6-63.5 35.1 0 63.5 28.4 63.5 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m82.6 98.9c-5.9-4.7-15.7-7.6-20.2-14-5.3-7.5-5.4-19.7 2.7-25.6-1.1 4.5 0 9.4 2.3 13.1 2.2 3.6 5.3 6.1 8.5 8.3 3.3 2.1 6.6 3.9 9.6 6.5 2.1 1.9 4.1 4.2 5.2 7.3 0.9 2.7 1.6 6.1 0.4 8.7-1.3 2.7-6.4 8.4-9.9 8 5.3-3.5 5.1-9.3 1.4-12.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m63.3 92.8c3.4 2 6.8 4.1 10.5 5.7 14.4 6.4 7.9 11.3 3.7 13.1 4.7-4.9-1.8-5.9-9.9-7.8-4.7-1.1-8.1-3.2-10.8-6.6-2.8-3.4-4.2-8.9-1.7-13.2 1.5 4.1 4.7 6.8 8.2 8.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "d",
    d: "m94.6 98.2c-2.6-22.3-25-22.5-24.4-41.6 0.1-3.2 1-6 2.4-8.2q0-0.2 0-0.2c0 0-6.9-1.4-7.9-3.3 0 0 5.1 1.7 8.8-0.4 0 0-5.2-0.9-6.5-4.6 0 0 3.7 2 10.8-0.4 0 0 4-1.6 5.6-1.1 0 0-3-3-2.6-3.8 0 0 7.4 3.8 8.6 2.8 0 0-5.2-6.9-9-8.7 0 0 8.5 2.3 11.7 7 0 0-2-12.3 2.7-15.1 0 0-3.6 4.7 1.1 13.5 0 0 5.8 8.3 5.8 12.7-0.1 4.5-1.6 8-4 8.3 0 0-2.8 6.1-4.9 6.9 0 0 1.1-4.5-0.3-7.6-1.4-3-3.3-6.1-1.9-9 0 0-4.1 3.2-4 7.2 0 0-1.8-2-1.1-4.5 0 0-1.1 2.3-0.7 5.8q0.1 0.3 0.1 0.6 0.2 0.6 0.4 1.2 0-0.1-0.1-0.2c2.4 7.5 9.4 9.5 15.5 20 3.9 6.6 5.2 15.2 2.6 22.7-2.5 7.5-11.8 12.8-19.7 13.4 7.1-3.3 11.5-8.9 11-13.4zm1.2-45.4c-0.1-0.3 0.1-0.8 0.1-0.8 1.1-2.8-0.3-6.5-0.5-7 0.3 0.9-0.6 4.9-0.7 5.1 0 0.2 0.8 2.2 1.1 2.7zm-0.4-7.8q0 0 0 0 0 0 0 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m99.9 21.2c0 0-3.1 5.8-1.2 9.9 2.7 6.2 3.2 10.9 3.2 10.9-1.9-5.3-3.2-4.2-6.1-10.6 0 0-1.6-3.8 4.1-10.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m65.6 112.3c-9.2 0.9-22.2-1.9-26.7-4.2 0 0-14.6-6.3-15.5-20.9-1.6-19.2 10.4-26.3 7.4-50.1 7.4 14.4 2.4 29.1 1.3 42.3-1.1 7.3 0.5 13.1 3.1 17.4 3.3 5.9 8.4 9.6 14.9 12.3 4.7 1.9 15.5 3.2 15.5 3.2zm2.2-1.9c-6.6-0.8-17-4-21.1-10.5-4.4-7-4.4-16-2.7-24.1 0.7-3.2 1.6-6.3 2.6-9.4 0.5-1.7 0.9-2.8 1.9-5 6.2-13.8 11.8-28.8 4.8-45.4 16 16 8.6 37.8 1.3 55.4-6.9 16.6-6 34.1 21.7 39.8m-15.9-0.9c-14.6-2.3-28.5-10.5-26.9-30.7q0-0.1 0-0.1c0.5-5.8 1.9-11.5 3.9-16.8 4.6-11.9 9.6-23.3 5.8-38.7 12.7 18.7 2.8 34-0.9 50.5-4.5 20.2-2.2 32.8 29.4 37.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrimsonFlameActive);
export default __webpack_public_path__ + "static/media/crimson-flame-active.223144fc9f9ae53653cec1f2c156d58a.svg";
export { ForwardRef as ReactComponent };